import React, { useEffect, useState } from "react";
import { DistributionsIntroduction } from "../types";
import { getDistributionIntroduction,postDistributionApply } from "../../service";
// import {Carousel} from "react-responsive-carousel";
import { useLoading } from "../../components/loading/LoadingProvider";
import { useHistory } from "react-router-dom";
// import usePhones from "../../routers/usePhones";
import { useModal } from "../../components/modal";
import img2 from '../../images/fx-page2.png';
import title from '../../images/fx-title.png';
import title1 from '../../images/fx-page1.png';
import btn from '../../images/fx-page2-btn.png';
import btn1 from '../../images/fx-page2-btn2.png';
import ss from '../../images/apply-success.png';
import ee from '../../images/apply-error.png';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import useUserInfo from "../../routers/useUserInfo";
import { delay } from "../../units";

const classnames = require('classnames')

function Distribution() {
    const [info, setInfo] = useState<DistributionsIntroduction>();
    const [isSuccess,seuSuccess] = useState(false);
    const [cover,setCover] = useState(false);
    const [animated,setAnimated] = useState(false)
    const [animated1,setAnimated1] = useState(false)
    const [selected, setSelected] = useState<boolean>(false);
    const loading = useLoading()
    const modal = useModal()
    const userData = useUserInfo()
    const { push, goBack, replace } = useHistory()
    const [tip,setTip] = useState(false)

    useEffect(() => {
        loading.showLoading()
        getDistributionIntroduction()
            .then(res => {
                // console.log(res.data)
                setInfo(res.data)
                loading.hideLoading()
                setTimeout(() => {
                    setAnimated(true)
                },500)
            }).catch(e => {
            loading.hideLoading()
            modal.show({
                title:'错误提示',
                content:'无法获取数据',
                showCancel:false,
                success(){
                    goBack()
                }
            })
        })
    },[])

    const handleSubmit = () => {
        if(!selected){
            modal.show({
                title:'提示',
                content:'请勾选同意《活动规则》',
                showCancel:false,
                success(){

                }
            })
            return
        }else{
            if(userData){
                loading.showLoading()
                postDistributionApply({
                    customerId:userData.id
                }).then(res => {
                    loading.hideLoading()
                    if(res.code === 1){
                        seuSuccess(true)
                        setCover(true)
                    }else if(res.code === 30001){
                        setCover(true)
                    }else{
                        modal.show({
                            title:'提示',
                            content:res.msg,
                            showCancel:false,
                            success(){

                            }
                        })
                    }
                })
            }
        }
    }


    return <div className="Distribution">
        <img src={ title } alt="" className="title"/>
        <Swiper onSlideChange={(swiper) => {
            swiper.activeIndex === 1 && delay(() => setAnimated1(true),300);
            setTip(false)
        } }>
            <SwiperSlide>
                <div className="item">
                    <img src={ title1 } className={ classnames("title1 animate",{animated:animated}) } alt=""/>
                    {
                        info && <img src={ info.imgUrl } onTransitionEnd={() =>  delay(() => {
                            setTip(true);
                            delay(() => setTip(false),2000)
                        },500) } alt="" className={ classnames("page1 animate delay-250",{animated:animated}) }/>
                    }
                </div>
            </SwiperSlide>
            <SwiperSlide>
                <div className="item">
                    <img src={ img2 } className={ classnames("animate delay-250",{animated:animated1}) } alt=""/>
                    <div className="box">
                        <div className={ classnames("content animate delay-350",{animated:animated1}) }>
                            <h3>【活动规则】</h3>
                            <div className="scroll-box">
                                <div className="scroll-content" dangerouslySetInnerHTML={{ __html: info ? info.ruleContent : '' }}/>
                            </div>
                        </div>
                        <p className={ classnames("_tip animate delay-450",{animated:animated1}) }>*活动最终解释权归TIBAChina所有。</p>

                        <div className={ classnames("selected animate delay-550",{animated:animated1}) } onClick={() => setSelected(o => !o)}>
                            <div className={selected ? 'active rect' : 'rect'}/>
                            <p>我已阅读并同意《活动规则》</p>
                        </div>

                        {
                            userData && (!userData.referee ? <img src={ btn } alt="" className={ classnames("_btn animate delay-650",{animated:animated1}) } onClick={ handleSubmit }/> :  <img src={ btn1 } alt="" className={ classnames("_btn animate delay-650",{animated:animated1}) } onClick={ () => replace('/home/distribution/lists') }/>)
                        }

                    </div>
                </div>
            </SwiperSlide>
        </Swiper>

        {
            cover &&  <div className="cover" onClick={() => !isSuccess && setCover(false)}>
                <div className="_box">
                    <img src={ isSuccess ? ss : ee } alt=""/>
                    {
                        isSuccess ?  <p className="common-btn" onClick={() => push('/home/distribution/detail')}>下一步</p> : <p className="common-btn">关闭</p>
                    }
                </div>


            </div>
        }

        {
            tip && <div className="tip">
                <p className="iconfont">&#xe646;</p>
                <div>左右滑动查看更多</div>
            </div>
        }

    </div>
}

export default Distribution
